module.exports = __webpack_public_path__ + "static/media/research_and_development.7ea2a516.png";